export default {"src":"/_next/static/media/babygirl.bfeaa171.svg","height":429,"width":560,"blurWidth":0,"blurHeight":0};